// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html {\n  scroll-behavior: unset;\n}\n\n.hide-scrollbar {\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* IE, Edge */\n}\n\n.hide-scrollbar::-webkit-scrollbar {\n  display: none; /* Chrome, Safari, Opera */\n}\n", ""]);
// Exports
module.exports = exports;
